import { ACTIVE_ROW_EDITING, SET_DATA_BY_DAY, UPDATE_DATA_BY_DAY} from "../actions/types";

const initialState = {
    activeRowEditing: null,
    dataByDay: [],
};

const TankMidnightReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case ACTIVE_ROW_EDITING:
            return { ...state, activeRowEditing: payload };

        case SET_DATA_BY_DAY:
            return { ...state, dataByDay: payload };

        case UPDATE_DATA_BY_DAY: {
            let id = payload.id
            return { ...state, dataByDay: state.dataByDay.map(x => x.id === id ? payload : x) }
        }

        default:
            return state;
    }
};

export default TankMidnightReducer;
